import { AlertOctagon } from "lucide-react";
import type { TransferRequest } from "@/features/employeeTransfer/types/employeeTransfer.types";
import { H2 } from "@/shared/ui/typographies/h2";
import { P } from "@/shared/ui/typographies/paragraph";

const SUPPORT_EMAIL = "support@yeati.co";

type FailedScreenProps = { transferRequest: TransferRequest };

export const FailedScreen = ({ transferRequest }: FailedScreenProps) => {
  const {
    source_organization_name: sourceOrg,
    target_organization_name: targetOrg,
  } = transferRequest;

  return (
    <div className="overflow-hidden rounded-xl" aria-live="polite">
      <div className="bg-red-50/80 px-6 py-8 dark:bg-red-950/20">
        <div className="flex flex-col items-center text-center">
          <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/30">
            <AlertOctagon size={28} className="text-red-600 dark:text-red-400" />
          </div>
          <H2 className="mb-2 text-xl font-bold text-gray-900 dark:text-white">
            Échec du transfert
          </H2>
          <P size="sm" color="base" className="text-pretty tracking-wider">
            Le transfert de votre compte de
            {" "}
            <strong className="text-gray-900 dark:text-white">{sourceOrg}</strong>
            {" "}
            vers
            {" "}
            <strong className="text-gray-900 dark:text-white">{targetOrg}</strong>
            {" "}
            n'a pas pu être effectué.
          </P>
        </div>
      </div>

      <div className="space-y-4 px-6 pb-6 pt-4">
        <div className="space-y-2 text-center">
          <P size="sm" color="base" className="text-pretty tracking-wider">
            Veuillez contacter le support de Yeati :
          </P>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="text-sm font-medium text-teal-600 underline hover:text-teal-700 dark:text-teal-400 dark:hover:text-teal-300"
          >
            {SUPPORT_EMAIL}
          </a>
        </div>
      </div>
    </div>
  );
};
